import { serializable, alias, object, primitive } from 'serializr';
import { Address } from 'models/Address/address.model';

export class MultipleOrigins {
  @serializable
  id?: number;

  @serializable(alias('activity_mapping_region_spec_id', primitive()))
  activityMappingRegionSpecId?: number;

  @serializable(alias('address', object(Address)))
  address?: Address;

  @serializable(alias('co2e', primitive()))
  co2e?: string;

  @serializable
  createdAt?: string;

  @serializable(alias('normalised_co2e', primitive()))
  normalisedCo2e?: number;

  @serializable
  order?: string;

  @serializable
  origin?: string;

  @serializable(alias('origin_share', primitive()))
  originShare?: number;

  @serializable(alias('units_per_packaging_material', primitive()))
  unitsPerPackagingMaterial?: string;

  @serializable
  updatedAt?: string;

  @serializable(alias('user_location_label', primitive()))
  userLocationLabel?: string;

  @serializable(alias('type', primitive()))
  type?: string;

  @serializable(alias('unit', primitive()))
  unit?: string;

  @serializable(alias('weight', primitive()))
  weight?: string;

  @serializable(alias('activity_label', primitive()))
  activityLabel?: string;

  @serializable(alias('normalised_co2e_stage', primitive()))
  normalisedCo2eStage?: number;

  @serializable(alias('leg_type', primitive()))
  legType?: string;

  @serializable(alias('origin_to_supplier_leg_type', primitive()))
  originToSupplierLegType?: string;

  @serializable(alias('supplier_to_pf_leg_type', primitive()))
  supplierToPfLegType?: string;

  @serializable(alias('product_raw_material_id', primitive()))
  productRawMaterialId?: number;
}
